export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/nr.d943a59d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};